import { useTranslation } from 'react-i18next'

import {
  PROVENANCE_ENTITY,
  useRentalPortalFieldOwnership,
} from '../../../../../RentalPortalProvenance'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'
import { getListingKeyFactsRows } from '../RentalPortalListingProfileKeyFactsWidget.utils'
import { RentalPortalListingProfileKeyFactsWidgetRow } from '../RentalPortalListingProfileKeyFactsWidgetRow'

import * as styles from '../RentalPortalListingProfileKeyFactsWidget.module.css'

function RentalPortalListingProfileKeyFactsWidgetReadView() {
  const { t } = useTranslation()

  const { listingData } = useListingProfileContext()

  const { getFieldOwnership } = useRentalPortalFieldOwnership()

  return (
    <div className={styles.rows}>
      {getListingKeyFactsRows({ listing: listingData, t }).map(
        ({ key, label, provenanceField, value }) => (
          <RentalPortalListingProfileKeyFactsWidgetRow
            key={key}
            label={label}
            ownership={getFieldOwnership({
              entity: PROVENANCE_ENTITY.flat,
              field: provenanceField,
            })}
            rowKey={key}
            value={value}
          />
        )
      )}
    </div>
  )
}

export default RentalPortalListingProfileKeyFactsWidgetReadView
